export class ReportsApiPaths {
    constructor(private readonly api: string) {}

    putRegenerateEdition = (reportId: string, reportEditionId: string) =>
        `${this.api}/${reportId}/editions/${reportEditionId}/regenerate`;
    readUpdateDeleteReport = (reportId: string) => `${this.api}/${reportId}`;
    createReport = () => `${this.api}`;
    duplicateReport = () => `${this.api}/duplicate`;
    getReportEditions = (reportId: string) => `${this.api}/${reportId}/editions`;
    getReportEdition = (reportId: string, reportEditionId: string) =>
        `${this.api}/${reportId}/editions/${reportEditionId}`;
    getReportTemplate = (reportId: string) => `${this.api}/${reportId}/templates`;
    getReportKpiNotificationSettings = (reportId: string) =>
        `${this.api}/${reportId}/kpi/notification-settings`;
    activateReport = (reportId: string) => `${this.api}/${reportId}/activate`;
    getReportShareList = (reportId: string) => `${this.api}/${reportId}/sharedProfiles`;
}
